import React from 'react';
import { map } from 'lodash';
import { button as Button } from 'modules/button';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { impersonateMember as ImpersonateMember } from 'ui/views/widgets/impersonateMember';
 *
 * // render
 * <ImpersonateMember propName='propValue'/>
 */
export const impersonateMember = ( props ) => {

	// form config
	const formConfig = {
		url: props.samlUrl,
		method: props.formConfig.method,
		target: props.formConfig.target,
	};

    return (
        <div className='ui-impersonate-member'>

			{/* header */}
			<div className='ui-impersonate-member__header'>

				{/* title for the modal */}
				<div className='ui-impersonate-member__header__title'>
					{ getLabel( props.title ) }
				</div>

				{/* close button */}
				<div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
					<Icon name='close' width='14' height='14' fill='#ffffff' />
				</div>

			</div>

			{/* body */}
			<div className='ui-impersonate-member__body'>
				
				{/* description */}
				<div className='ui-impersonate-member__body__description'>
					{ getLabel( props.description, props.memberInfo ) }
				</div>
				
				{/* form */}
				<form className='ui-impersonate-member__body__form' action={ formConfig.url } method={ formConfig.method } target={ formConfig.target }>

					{/* hidden input field */}
					<input type='hidden' value={ props.samlResponse } name='SAMLResponse' />

					{/* actions */}
					<div className='ui-impersonate-member__body__form__actions'>
						{ map( props.actions, action => {
							return (
								<Button
									key={ action.name }
									{ ...action }
									size='medium'
									className='ui-impersonate-member__body__form__actions__action'
									type={ 'cancel' === action.name ? 'button' : 'submit' }
									outline={ 'cancel' === action.name ? true: false }
									onClick={ () => props.closeOverlay() }
								/>
							);
						} ) }
					</div>

				</form>
			</div>
        </div>
    );
};

// set display name
impersonateMember.displayName = 'impersonateMember';

// set default props
impersonateMember.defaultProps = {};

// prop types
impersonateMember.propTypes = {};
